import ChartStoreItem from '../models/chart_store_item';
import ChartData from '../models/chart_data';
import ChartActionRoutes from '../constants/chart_action_routes';

import RestClient from 'rest_client/rest_client';
import ResponseHandler from 'rest_client/response_handler';
import { ProcessAPI } from 'lecom-api';
import { FormEvents, FormElements, FormEventHandler } from '../../form/events/form_event_handler';

import { serializePrivateProperties } from 'utils/object_utils';

export const ChartActions = Reflux.createActions([
	'init',
	'loadChartData',
	'updateChartData',
	'chartItemClick'
]);

export const ChartStore = Reflux.createStore({
	listenables: ChartActions,
	store: {},

	onInit(inputChartId, inputProps = {}) {
		this.store[inputChartId] = new ChartStoreItem(inputProps);
		this.onLoadChartData(inputChartId);
	},

	onLoadChartData(inputChartId) {
		const storeItem = this.store[inputChartId];
		const processIds = serializePrivateProperties(ProcessAPI.currentProcess().processIds());
		this.performLoadChartDataRequest(storeItem, processIds);
	},

	onUpdateChartData(inputChartId, chartData) {
		const storeItem = this.store[inputChartId];
		storeItem.chartData = new ChartData(chartData);
		storeItem.chartLoaded = true;
		// console.log('storeItem ', storeItem);
		this.trigger(this.store);
	},

	onChartItemClick(inputChartName, chartItemLinkJavascript) {
		FormEventHandler.publish(FormEvents.CHART_ITEM_CLICK, FormElements.FIELD, inputChartName, chartItemLinkJavascript);
	},

	/* loadChartData functions */

	performLoadChartDataRequest(storeItem, processIds) {
		const url = ChartActionRoutes.GET_CHART_DATA;
		const params = this.buildLoadChartDataRequestParams(storeItem, processIds);

		RestClient.get(url, params).then(
			this.handleLoadChartDataResponse.bind(this, storeItem),
			ResponseHandler.displayErrorResponseFlashMessage.bind(this, 'flash-form')
		);
	},

	handleLoadChartDataResponse(storeItem, response) {
		const responseData = response.entity;
		const inputChartId = storeItem.inputId;

		this.onUpdateChartData(inputChartId, responseData);
	},

	buildLoadChartDataRequestParams(storeItem, processIds) {
		return Object.assign({}, processIds, {
			fieldName: storeItem.inputName
		});
	}

});

export default ChartStore;
